import { render, staticRenderFns } from "./KnowAlpha.vue?vue&type=template&id=32419f57&scoped=true&"
import script from "./KnowAlpha.vue?vue&type=script&lang=js&"
export * from "./KnowAlpha.vue?vue&type=script&lang=js&"
import style0 from "./KnowAlpha.vue?vue&type=style&index=0&id=32419f57&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32419f57",
  null
  
)

export default component.exports